import { render, staticRenderFns } from "./NoProductOffer.vue?vue&type=template&id=18a7d1a4&scoped=true"
import script from "./NoProductOffer.vue?vue&type=script&lang=ts"
export * from "./NoProductOffer.vue?vue&type=script&lang=ts"
import style0 from "./NoProductOffer.vue?vue&type=style&index=0&id=18a7d1a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a7d1a4",
  null
  
)

export default component.exports